import { getFromLS } from '@orientaction/utils';

export const isRootUser = (user: any) => {
  if (!user) {
    return false;
  }
  const { role } = user;

  if (role?.type === 'admin') {
    return true;
  }
  return false;
};

export const isAdmin = (user: any, defineCompanyRolesAdmin = [1, 2, 3, 4]) => {
  if (!user || (typeof user === 'object' && Object.keys(user).length === 0)) {
    return false;
  }
  const { company_user_role, role } = user;

  if (role?.type === 'admin' || defineCompanyRolesAdmin.indexOf(company_user_role?.id) > -1) {
    return true;
  }

  if (role?.type === 'authenticated') {
    return false;
  }

  if (company_user_role?.id === 5) {
    return false;
  }

  if (!company_user_role) {
    return true;
  }

  return false;
};

export const isAdminVerify = () => {
  const raw = getFromLS('userInfos');
  if (!raw) {
    return false;
  }

  let userInfos: any;
  try {
    userInfos = JSON.parse(raw);
  } catch {
    return false;
  }

  if (!userInfos) {
    return false;
  }

  const { company_user_role, role } = userInfos;

  if (
    role?.type === 'admin' ||
    company_user_role?.id === 1 ||
    company_user_role?.id === 2 ||
    company_user_role?.id === 3 ||
    company_user_role?.id === 4
  ) {
    return true;
  }

  if (role?.type === 'authenticated') {
    return false;
  }

  if (company_user_role?.id === 5) {
    return false;
  }

  if (!company_user_role) {
    return true;
  }

  return false;
};

export const isTopManager = (companyRoleId: string | number) => {
  return [1, 2, 3].includes(+companyRoleId);
};
